import { useQuery } from '@tanstack/react-query';

import type { Core } from '@strapi/types';
import { getFilteredDocumentsList } from '../api/document.api';

export const useFilteredDocumentsListInit = ({
	projectId,
	date,
	documentType,
	projectDocumentId,
}: Core.Helpers.Controllers.GetRequestBody<'api::project-document.project-document', 'getFilteredDocumentsList'>) => {
	const {
		data: projectDocuments,
		error,
		isLoading,
		refetch,
	} = useQuery({
		queryKey: ['GET_FILTERED_PROJECT_DOCUMENTS_LIST', projectId, projectDocumentId, date, documentType].filter(Boolean),
		queryFn: () => getFilteredDocumentsList({ projectId, date, documentType, projectDocumentId }),
		enabled: !!projectId,
		refetchOnWindowFocus: true,
	});

	return {
		projectDocuments,
		error,
		isLoading,
		refetch,
	};
};
